<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="dashboard global__scrollcustom">
          <div class="dashboard__notif-and-todo">
            <div class="d-flex mb-4">
              <router-link tag="div" class="mr-2" :to="{ name: 'Dashboard' }">
                <img src="@/assets/image/icon/New-arrow.svg" alt="">
              </router-link>
              <p style="line-height: 1.7; font-size: 16px;">Dashboard</p>
            </div>
            <div>
              <h4 class="title">{{tabActive}}</h4>
            </div>
            <!-- <div class="row m-0 align-items-start">
              <router-link tag="div" class="mr-2" :to="{ name: 'Dashboard' }">
                <img class="back-image" src="@/assets/image/icon/arrow-down-full-blue.svg" alt="">
              </router-link>
              <button v-for="item in tabList" class="dashboard__notif-and-todo--tabs"
              :class="{'tab-active' : item.text === tabActive}"
              @click="switchTab(item.text)" :key="item.id">
                <b>{{item.text}}</b>
              </button>
            </div> -->
            
            <div>
              <List
                :isLoading="isLoadingItemTodoAll"
                :dataList="tabActive === 'Notifications' ? notifData : todoData"
                :tabActive="tabActive"
              />
            </div>
            <div class="row m-0 paginationCustom py-3">
              <div class="col-md-12 d-flex justify-content-end" v-if=" todoData.length > 0 || notifData.length > 0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import List from '@/components/dashboard/notifAndToDo/List.vue'
import dashboardMixin from '@/mixin/dashboard/invoice_notif_todolist'
import { mapGetters } from 'vuex'

export default {
  name: 'NotifAndTodo',
  components: {
    Sidebar,
    List
  },
  mixins: [dashboardMixin],
  data: () => ({
    tabActive: 'To Do List',
    notifData: [],
    todoData: [],
    currentPage: 1,
    perPage: 10,
    totalRows: 0
  }),
  methods: {
    checkTabs (type) {
      if (type === 'notifications') {
        this.tabActive = 'Notifications'
      } else if (type === 'to-do-list') {
        this.tabActive = 'To Do List'
      } else {
        this.$router.push({ name: 'NewDashboard' })
      }
    },
    switchTab (item) {
      this.tabActive = item
      this.currentPage = 1
    },
    async getTodolistAll () {
      await this.$store.dispatch('dashboard/FETCH_TODO_ALL', {currentPage: this.currentPage, perPage: this.perPage})
    },
    async getNotifAll () {
      await this.$store.dispatch('dashboard/FETCH_NOTIFICATION_ALL', this.currentPage)
    }
  },
  computed: {
    ...mapGetters({
      itemTodoAll: 'dashboard/itemTodoAll',
      isLoadingItemTodoAll: 'dashboard/isLoadingItemTodoAll',
      errorItemTodoAll: 'dashboard/errorItemTodoAll',

      itemNotifAll: 'dashboard/itemNotifAll',
      isLoadingItemNotifAll: 'dashboard/isLoadingItemNotifAll',
      errorItemNotifAll: 'dashboard/errorItemNotifAll'
    })
  },
  created () {
    this.checkTabs(this.$route.params.type)
    this.getTodolistAll()
    this.getNotifAll()
  },
  watch: {
    itemTodoAll (data) {
      if (data) {
        this.todoData = []
        this.totalRows = data.totalRecord
        data.data.forEach(item => {
          const obj = Object.assign(
            { alertImage: this.getAlertImage(item.priority) },
            { messageImage: this.getIconMessage(item.topic) },
            { messageType: this.getMessageType(item) },
            { status: this.getStatus(item) },
            { message: this.getMessageDetail(item) },
            item
          )
          this.todoData.push(obj)
        })
      }
    },
    itemNotifAll (data) {
      if (data) {
        this.totalRows = data.total
        this.notifData = []
        const readList = []
        const unreadList = []
        data.data.forEach(item => {
          const obj = Object.assign(
            { alertImage: this.getAlertImage(item.priority) },
            { messageImage: this.getIconMessage(item.topic) },
            { messageType: this.getMessageType(item) },
            { status: this.getStatus(item) },
            { message: this.getMessageDetail(item) },
            item
          )
          if (item.isRead) {
            readList.push(obj)
          } else {
            unreadList.push(obj)
          }
        })
        this.notifData = unreadList.concat(readList)
      }
    },
    currentPage () {
      if (this.tabActive.toLowerCase() === 'to do list') {
        this.getTodolistAll()
      } else {
        this.getNotifAll()
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/view/dashboard/pages/NotifAndToDo.vue